// extracted by mini-css-extract-plugin
export var cancelButton = "_n9-5";
export var content = "_n9-3";
export var createButton = "_n9-6";
export var drawerContainer = "_n9-0";
export var footer = "_n9-2";
export var header = "_n9-1";
export var orderFormColumn = "_n9-4";